<div class="swiper-outer">
  <div
    class="pb-5 w-full overflow-hidden"
    [style.--swiper-template-count]="templates.length"
    [style.--swiper-index]="index"
    [style.--swiper-offset]="offset + 'px'"
  >
    <div
      class="swiper-inner-container"
      [class.swiping]="swiping"
      libSwipe
      [swipeMode]="'horizontal'"
      (onSwipe)="onSwipe($event)"
      (onChangeOffset)="offset = $event.x"
      (onSwipeEvent)="swipeEvent($event)"
    >
      <div
        class="swiper-item"
        [style.width]="100 / templates.length + '%'"
        *ngFor="let tpl of templates; let i = index"
      >
        <ng-content />
        <!-- please don't remove this: https://github.com/angular/angular/issues/50543 -->
        <ng-container [ngTemplateOutlet]="tpl"></ng-container>
      </div>
    </div>
  </div>
  <div class="dots pb-5" *ngIf="templates.length > 1 && numberOfDots > 1">
    <div class="dot" *ngFor="let t of templates; let i = index" [class.active]="index === i" (click)="index = i"></div>
  </div>
  <div class="arrows" *ngIf="!hideArrows && templates.length > 1 && numberOfDots > 1">
    <div class="arrow left" [class.disabled]="index === 0" (click)="onSwipe('left')"></div>
    <div
      class="arrow right"
      [class.disabled]="index === numberOfDots - 1"
      (click)="onSwipe('right')"
      data-testid="swiper-right-arrow"
    ></div>
  </div>
</div>
